import WarningTriangleIcon from '@/components/icons/warning-triangle';
import { cn } from '@/lib/utils';

export const FormFieldError = ({ error }: { error?: string }) => (
  <div aria-hidden={!error} className={cn('text-default-red flex items-center gap-2 text-sm', !error && 'hidden')}>
    <WarningTriangleIcon size={20} className="flex-shrink-0" />
    <span>{error}</span>
  </div>
);
